import React from "react";
import { useShowContextRequired } from "ui-builder";
import { ProjectDetailsField } from "nekst-api";
import { TextBadge, TextBadgeVariant } from "features/nekst-widgets";
import { NewLineBadgeLayout } from "./NewLineBadgeLayout";

export function IsStartDateField() {
  const showContext = useShowContextRequired<ProjectDetailsField>();

  const data = showContext.data;

  if (data.isProjectStartDate) {
    return (
      <NewLineBadgeLayout>
        <TextBadge
          text="Start Date"
          variant={TextBadgeVariant.PRIMARY}
          isSmall
          title="Used as the start date when creating transactions from contracts"
        />
      </NewLineBadgeLayout>
    );
  } else {
    return null;
  }
}

export function IsEndDateField() {
  const showContext = useShowContextRequired<ProjectDetailsField>();

  const data = showContext.data;

  if (data.isProjectEndDate) {
    return (
      <NewLineBadgeLayout>
        <TextBadge
          text="End Date"
          variant={TextBadgeVariant.PRIMARY}
          isSmall
          title="Used as the end date when creating transactions from contracts"
        />
      </NewLineBadgeLayout>
    );
  } else {
    return null;
  }
}
